import React from "react";
import { Link } from "react-router-dom";
import configuration from "react-global-configuration";
import "./StandalonePageLogo.css";

/**
 * Pentecost+ logo for pages without global navigation (auth, profiles, landing).
 * Reuses UserHeader brand classes (.navbar-brand, .logo-img, .desktop-logo,
 * .mobile-logo) so size/padding track global style.css + responsive.css + Bootstrap.
 */
export function StandalonePageLogo({ linkTo = "/", className = "" }) {
  const siteLogo =
    configuration.get("configData.site_logo") || "/logo.png";
  const siteIcon =
    configuration.get("configData.site_icon") || siteLogo;
  const alt = configuration.get("configData.site_name") || "Pentecost+";
  const extraClass = className ? ` ${className}` : "";

  const images = (
    <>
      <img
        src={siteLogo}
        className={`logo-img desktop-logo${extraClass}`}
        alt={alt}
      />
      <img
        src={siteIcon}
        className={`logo-img mobile-logo${extraClass}`}
        alt={alt}
      />
    </>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="navbar-brand">
        {images}
      </Link>
    );
  }

  return images;
}

/**
 * Shared header wrapper for standalone pages.
 * Applies .navbar.main-nav so padding matches #header at every breakpoint;
 * chrome (bg / shadow / fixed) is neutralized in StandalonePageLogo.css.
 * variant: "auth" (relative) | "account" (absolute overlay) | "landing" (absolute flex bar)
 */
export function StandalonePageHeader({ variant = "auth", className = "", children }) {
  const headerClassName = [
    "standalone-page-header",
    "navbar",
    "main-nav",
    `standalone-page-header--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <div className={headerClassName}>{children}</div>;
}

export default StandalonePageLogo;
